<template>
    <b-container fluid>
        <b-row class="justify-content-center">
            <b-col>
                <b-alert show variant="warning" class="text-center">
                    <h2>Señor supervisor, por favor ingrese a través de su dispositivo a https://bitacorapp.com</h2>
                </b-alert>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-col class="text-center">
                <app-sub-title text="De ahora en adelante no tendrá que hacer uso del puesto del vigilante"></app-sub-title>
            </b-col>
        </b-row>
        <br />
        <b-form-row>
            <b-col cols="12" md="6" offset-md="3">
                <b-btn
                    squared
                    variant="confirm"
                    @click="goTo('supervisionCameraReview')"
                    style="min-height: 70px;"
                    :disabled="!clientSelected"
                    block
                    >Formato Revisión de Camaras</b-btn
                >
            </b-col>
        </b-form-row>
    </b-container>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { SET_SUPERVISION_CLIENT } from '@store/commitTypes'

export default {
    computed: {
        ...mapGetters(['client', 'supervisionClient']),
        clientSelected() {
            return !!this.supervisionClient
        },
    },
    methods: {
        ...mapMutations({
            setSupervisionClient: SET_SUPERVISION_CLIENT,
        }),
        initialize() {
            if (this.client) {
                this.setSupervisionClient(this.client)
            }
        },
        goTo(action) {
            this.$router.push({ name: action })
        },
    },
    created() {
        this.initialize()
    },
}
</script>
